import http from '@/shared/api/http'

export async function getBrandCharacteristicValueCodes(brandId) {
  return (await http.get(`/brands/${brandId}/characteristic-value-codes`)).data
}

export async function saveBrandCharacteristicValueCode(brandId, characteristicValueId, suffix) {
  return (await http.put(`/brands/${brandId}/characteristic-value-codes/${characteristicValueId}`, { suffix })).data
}

export async function deleteBrandCharacteristicValueCode(brandId, characteristicValueId) {
  return (await http.delete(`/brands/${brandId}/characteristic-value-codes/${characteristicValueId}`)).data
}
